import React, { useEffect, useState } from "react";
import Logo from "../../../Pyragon/PyraGon.png";
import Twitter from "../../../Pyragon/twitter.png";
import Email from "../../../Pyragon/discord.png";
import TeleGeam from "../../../Pyragon/telegram.png";
import Bitcoin from "../../../Pyragon/medium.png";
import Modal2 from "../../modals/modal2/Modal2";
import "./navbar-desktop.css";
import HamburgerMenu from "react-hamburger-menu";
import { Link } from "react-router-dom";
const NavBarDesktop = () => {
  const [openModal2, setOpenModal2] = useState(false);

  const HandleModal2 = () => {
    setOpenModal2(true);
  };

  return (
    <div id="nav-bar" className="nav-bar">
      <div id="title">
        <img
          alt=""
          src={Logo}
          style={{ width: "40px", height: "40px", marginRight: "10px" }}
        />
       <a>PYRAGON</a> 
      </div>
      <div style={{ display: "none" }}>
        <div id="nav-bar-modal2-wrapper">
          <Modal2 isOpen={openModal2} setIsOpen={setOpenModal2} />
        </div>
      </div>

      <div id="nav-links-gorup">
        {/* <a class="nav-link" href="#about-section">
          ABOUT
          <Link to="/about" style={{ color: "white", textDecoration: "none" }}>
            ABOUT{" "}
          </Link>
        </a> */}

        <a class="nav-link" onClick={HandleModal2}>
          TOKENOMICS
        </a>

        <a class="nav-link" href="#features">
          FEATURES
        </a>

        <a class="nav-link" href="#roadmap-main-container">
          ROADMAP
        </a>

        <a class="nav-link" href="#main-container-our-team">
          TEAM
        </a>

        <a class="nav-link" href="#container-footer">
          CONTACT
        </a>

        <a class="nav-link" href="#document-main-container">
          DOCUMENTS
        </a>
      </div>

      <div id="social">
        <a href="https://t.me/pyragonio" class="social-link">
          <img src={TeleGeam} style={{ width: "20px", height: "20px" }} />
        </a>
        <a href="https://twitter.com/pyragonio?s=21" class="social-link">
          <img src={Twitter} style={{ width: "20px", height: "20px" }} />
        </a>
        <a href="https://discord.gg/maEb3zVU" class="social-link">
          <img src={Email} style={{ width: "25px", height: "22px" }} />
        </a>
        <a class="social-link">
          <img
            alt="first"
            src={Bitcoin}
            style={{ width: "20px", height: "18px" }}
          />
        </a>
      </div>
      <div id="dashboard">
        <Link to="/about">
        <button>DASHBOARD</button>
        </Link>
      </div>
    </div>
  );
};

export default NavBarDesktop;
